import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeCustomModalDialog } from '../../redux/slices/modalSlice';
import CustomDialog from './Dialog';
import PropTypes from 'prop-types';
import DeleteModal from './DeleteModal';
import BulkDeleteModal from './BulkDeleteModal';
import BulkBrandUpdate from './BulkBrandUpdate';
import BulkProductStatusUpdate from './BulkProductStatusUpdate';
import BulkProductPriceUpdate from './BulkProductPriceUpdate';
import BulkSalePriceUpdate from './BulkSalePriceUpdate';
import BulkProductCategoryUpdate from './BulkProductCategoryUpdate';
import BulkProductTagsUpdate from './BulkProductTagsUpdate';
import WarrantyReason from './orders/ReturnReason';
import ChangeOrderStatus from './ChangeOrderStatus';
import CancelOrderReason from './orders/CancelOrderReason';
import BanMemberModal from './member/BanMemberModal';
import DeclineStoreProductReason from './approvals/DeclineStoreProductReason';
import OverrideApproval from './ApprovalOverride';
import ImportDriversModal from './Hyperwolf/ImportDriversModal';
import DeclineDriverRequestReason from './Hyperwolf/DeclineDriverRequestReason';
import BulkDeleteDriver from './BulkDeleteDriver';
import DriverTaskModal from './DriverTaskModal';
import FetchDriveMessage from './FetchDriveMessage';
import UploadIdImageModal from './UploadIdImageModal';
import HotNotesModal from './HotNotesModal';
import DeliveryOrderReason from './orders/DeliveryOrderReason'
import AddRefundReason from './AddRefund';
import ChangeRefundStatus from './ChangeRefundStatus';
import AddNewUnitModal from './AddNewUnitModal';
import AddNewStrainModal from './AddNewStrainModal';
import AddNewStrainModalHw from './Hyperwolf/AddNewStrainModal';
import SocialMediaUpload from './SocialMediaUpload';
import MediaUploadModal from './MediaUploadModal';
import ActiveCard from './ActiveCard';
import AddWalletReason from './AddWalletReason';
import TemplateCreate from './TemplateCreateModal';
import ConfirmModalStatus from './ConfirmModal';
import PaymentRefundReason from './Hyperwolf/paymentRefundReason';
import AddMetrcData from './AddMetrcData';
import AddMetrcTaxData from './AddMatrcTax';
import AddAgingRule from './AddAgingRuleModal';
import BulkProductCategoriesStatusUpdate from './BulkProductCategoriesStatusUpdate';
import SlotRollBack from './SlotRollback';
import UpdateAssignedSubRegion from "./Hyperwolf/updateAssignedSubRegion";
import DriverList from "./Hyperwolf/driverList";
import AssignProductsModal from "./Hyperwolf/assignProducts";
import PlannerOverrideNotes from "./Hyperwolf/plannerOverrideNotes";
import AddDiscrepancyNote from "./Hyperwolf/AddDiscrepancyNote";
import PinCodeModal from "./Hyperwolf/pinCodeModal";
import FreezeDistribution from "./Hyperwolf/freezeDistribution";
import AssignProductToBox from "./Hyperwolf/assignProductToBox";
import ConfirmationModal from "./confirmationModal";
import AddClosureDiscrepancy from "./Hyperwolf/AddClosureDiscrepancy";
import AssignQtyToBox from "./Hyperwolf/assignQtyToBox";
import AddRegion from "./Hyperwolf/addRegion";
import DriverCloserForm from './Hyperwolf/driverCloserForm';
import AssignQtyToDriver from './Hyperwolf/assignQtyToDriver';
import UploadFromDeviceImage from './UploadFromDeviceImage';
import UploadFromLibraryImage from './UploadFromLibraryImage';
import AddState from './AddStateModal';
import AddItems from './AddItemsModal';
import AddGridBanner from './AddGridBannerModal';
import AddHomeBanner from './AddHomeBannerModal';
import AddBannerModal from './AddBannerModal';
import AddCarouselPlatformModal from './Hyperwolf/AddCarouselPlatformModal';
import DriverKitTransactionSummaryModal from './Hyperwolf/DriverKitTransactionSummaryModal';
import SelectRegionModal from './Hyperwolf/SelectRegionModal';


export default function CustomModal() {
  const dispatch = useDispatch();
  const { modal, modalData } = useSelector(state => state.modal);
  const closeModal = () => {
    dispatch(closeCustomModalDialog());
  }

  switch (modal) {

    case 'CREATE_USER':
      return <RenderModalWithComponent component={Login} customFunction={closeModal} />
    case 'DELETE_MODAL':
      return <RenderModalWithComponent component={DeleteModal} customFunction={closeModal} maxWidth='xs' />
    case 'CONFIRMATION_MODAL':
      return <RenderModalWithComponent component={ConfirmationModal} customFunction={closeModal} maxWidth='xs' />
    case 'BULK_DELETE_PRODUCT':
      return <RenderModalWithComponent component={BulkDeleteModal} customFunction={closeModal} />
    case 'SOCIAL_MEDIA_UPLOAD':
      return <RenderModalWithComponent component={SocialMediaUpload} customFunction={closeModal} />;
    case 'IMAGE_MODAL_SEO':
      return <RenderModalWithComponent component={MediaUploadModal} customFunction={closeModal} />;
    case 'ACTIVE_CARD':
      return <RenderModalWithComponent component={ActiveCard} customFunction={closeModal} maxWidth='xs' />;

    case 'BULK_UPDATE_BRAND':
      return <RenderModalWithComponent component={BulkBrandUpdate} customFunction={closeModal} />
    case 'STATIC_TEMPLATE_ADD':
      return <RenderModalWithComponent component={TemplateCreate} customFunction={closeModal} maxWidth='xs' />

    case 'ADD_AGING_RULE':
      return <RenderModalWithComponent component={AddAgingRule} customFunction={closeModal} modalData={modalData} maxWidth='xs' className="add-aging-rule-modal" />

    case 'REFUND_REASON_ADD':
      return <RenderModalWithComponent component={AddRefundReason} customFunction={closeModal} />;

    case 'WALLET_REASON_ADD':
      return <RenderModalWithComponent component={AddWalletReason} customFunction={closeModal} />;

    case 'SOCIAL_MEDIA_UPLOAD':
      return <RenderModalWithComponent component={SocialMediaUpload} customFunction={closeModal} />;
    case 'BULK_UPDATE_STATUS':
      return <RenderModalWithComponent component={BulkProductStatusUpdate} customFunction={closeModal} />

    case 'BULK_UPDATE_PRICE':
      return <RenderModalWithComponent component={BulkProductPriceUpdate} customFunction={closeModal} />

    case 'BULK_UPDATE_SALE_PRICE':
      return <RenderModalWithComponent component={BulkSalePriceUpdate} customFunction={closeModal} />

    case 'BULK_UPDATE_CATEGORY':
      return <RenderModalWithComponent component={BulkProductCategoryUpdate} customFunction={closeModal} />

    case 'BULK_UPDATE_TAGS':
      return <RenderModalWithComponent component={BulkProductTagsUpdate} customFunction={closeModal} />

    case 'CHANGE_ORDER_STATUS':
      return <RenderModalWithComponent component={ChangeOrderStatus} customFunction={closeModal} />

    case 'CHANGE_REFUND_STATUS':
      return <RenderModalWithComponent component={ChangeRefundStatus} customFunction={closeModal} />
    case 'CONFIRM_SAVE_MODAL':
      return <RenderModalWithComponent component={ConfirmModalStatus} customFunction={closeModal} maxWidth='xs' />

    case 'WARRANTY_REASON':
      return <RenderModalWithComponent component={WarrantyReason} customFunction={closeModal} className='pro-return-reason-modal' />

    case 'CANCEL_ORDER_REASON':
      return <RenderModalWithComponent component={CancelOrderReason} customFunction={closeModal} />

    case 'DELIVERY_ORDER_REASON':
      return <RenderModalWithComponent component={DeliveryOrderReason} customFunction={closeModal} className="refund-process-modal" />

    case 'PAYMENT_REASON':
      return <RenderModalWithComponent component={PaymentRefundReason} customFunction={closeModal} className="refund-process-modal" />

    case 'BAN_MEMBER':
      return <RenderModalWithComponent component={BanMemberModal} customFunction={closeModal} />

    case 'DECLINE_APPROVAL_REASON':
      return <RenderModalWithComponent component={DeclineStoreProductReason} customFunction={closeModal} />

    case 'OVERRIDE_APPROVAL':
      return <RenderModalWithComponent component={OverrideApproval} customFunction={closeModal} maxWidth='xs' />

    case 'IMPORT_DRIVERS':
      return <RenderModalWithComponent component={ImportDriversModal} customFunction={closeModal} maxWidth='xs' />

    case 'DECLINE_DRIVER_REQUEST_REASON':
      return <RenderModalWithComponent component={DeclineDriverRequestReason} customFunction={closeModal} />

    case 'BULK_DELETE_DRIVER':
      return <RenderModalWithComponent component={BulkDeleteDriver} customFunction={closeModal} />

    case 'TASK_ROUTE':
      return <RenderModalWithComponent component={DriverTaskModal} customFunction={closeModal} className='bg-black task-route-modal' maxWidth='xs' />

    case 'DRIVER_FETCH':
      return <RenderModalWithComponent component={FetchDriveMessage} customFunction={closeModal} className='bg-black task-route-modal' maxWidth='xs' />

    case 'HOT_NOTES':
      return <RenderModalWithComponent component={HotNotesModal} customFunction={closeModal} maxWidth='sm' />

    case 'UPLOAD_IMAGE_CAMERA_AND_FILE_UPLOAD':
      return <RenderModalWithComponent component={UploadIdImageModal} customFunction={closeModal} maxWidth='xs' />

    case 'ADD_BANNER_MODAL':
      return <RenderModalWithComponent component={AddBannerModal} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />


    case 'ADD_NEW_UNIT_MODAL':
      return <RenderModalWithComponent component={AddNewUnitModal} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />

    case 'ADD_NEW_STRAIN_MODAL':
      return <RenderModalWithComponent component={AddNewStrainModal} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />

    case 'ADD_NEW_STRAIN_MODAL_HW':
      return <RenderModalWithComponent component={AddNewStrainModalHw} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />
    case 'ADD_METRC_DATA':
      return <RenderModalWithComponent component={AddMetrcData} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />
    case 'ADD_METRC_TAX_DATA':
      return <RenderModalWithComponent component={AddMetrcTaxData} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />
    case 'SLOT_ROLLBACK_DATA':
      return <RenderModalWithComponent component={SlotRollBack} customFunction={closeModal} maxWidth='sm' className="slot-roll-back-modal" />
    case 'BULK_PRODUCT_CATEGORIES_STATUS_UPDATE':
      return <RenderModalWithComponent component={BulkProductCategoriesStatusUpdate} customFunction={closeModal} />
    case 'UPDATE_ASSIGNED_SUBREGION':
      return <RenderModalWithComponent component={UpdateAssignedSubRegion} customFunction={closeModal} />
    case 'DRIVER_LIST':
      return <RenderModalWithComponent component={DriverList} customFunction={closeModal} maxWidth='xs' />
    case 'ASSIGN_PRODUCTS':
      return <RenderModalWithComponent component={AssignProductsModal} customFunction={closeModal} maxWidth={"xl"} />
    case 'PLANNER_OVERRIDE_NOTES':
      return <RenderModalWithComponent component={PlannerOverrideNotes} customFunction={closeModal} maxWidth='sm' />
    case 'ADD_DISCREPANCY_NOTE':
      return <RenderModalWithComponent component={AddDiscrepancyNote} customFunction={closeModal} maxWidth='sm' className="add-discrepancy-note-modal" />
    case 'DELETE_DISCREPANCY':
      return <RenderModalWithComponent component={PinCodeModal} customFunction={closeModal} maxWidth='sm' className="add-discrepancy-note-modal" />
    case 'ADD_CLOSURE_FORM_DISCREPANCY':
      return <RenderModalWithComponent component={AddClosureDiscrepancy} customFunction={closeModal} maxWidth='sm' className="add-discrepancy-note-modal" />
    case 'FREEZE_DISTRIBUTION':
      return <RenderModalWithComponent component={FreezeDistribution} customFunction={closeModal} maxWidth='sm' />
    case 'ASSIGN_PRODUCTS_TO_BOX':
      return <RenderModalWithComponent component={AssignProductToBox} customFunction={closeModal} maxWidth='sm' className="add-aging-rule-modal" />
    case 'BULK_ASSIGN_QTY':
      return <RenderModalWithComponent component={AssignQtyToBox} customFunction={closeModal} maxWidth='sm' className="add-aging-rule-modal" />
    case 'ADD_REGION':
      return <RenderModalWithComponent component={AddRegion} customFunction={closeModal} maxWidth='sm' className="add-aging-rule-modal" />
    case 'DRIVER_CLOSER_FORM':
      return <RenderModalWithComponent component={DriverCloserForm} customFunction={closeModal} maxWidth='sm' className="add-aging-rule-modal" />
    case 'BULK_ASSIGN_QTY_PER_DRIVER':
      return <RenderModalWithComponent component={AssignQtyToDriver} customFunction={closeModal} maxWidth='sm' className="add-aging-rule-modal" />
    case 'ADD_DEVICE_IMAGE_MODAL':
      return <RenderModalWithComponent component={UploadFromDeviceImage} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />
    case 'LIBRARY_MANAGE_IMAGE_MODAL':
      return <RenderModalWithComponent component={UploadFromLibraryImage} customFunction={closeModal} maxWidth='xs' className="add-trait-banner" />
    case 'ADD_STATE':
      return <RenderModalWithComponent component={AddState} customFunction={closeModal} maxWidth='xs' />
    case 'ADD_HOME_BANNER':
      return <RenderModalWithComponent component={AddHomeBanner} customFunction={closeModal} />;
    case 'ADD_ITEMS':
      return <RenderModalWithComponent component={AddItems} customFunction={closeModal} />;
    case 'ADD_GRID_BANNER':
      return <RenderModalWithComponent component={AddGridBanner} customFunction={closeModal} />;
    case 'ADD_CAROUSEL_PLATFORM':
      return <RenderModalWithComponent component={AddCarouselPlatformModal} customFunction={closeModal} maxWidth='xs' />;
    case 'DRIVER_KIT_TRANSACTION_SUMMARY':
      return (
        <RenderModalWithComponent
          component={DriverKitTransactionSummaryModal}
          customFunction={closeModal}
          maxWidth='sm'
          className="driver-kit-transaction-summary-modal"
        />
      );
    case 'SELECT_REGION_MODAL':
      return <RenderModalWithComponent component={SelectRegionModal} customFunction={closeModal} maxWidth='xs' />;

    default:
      return null


  }
}
const RenderModalWithComponent = ({ component: Component, maxWidth = 'sm', className, customFunction, paperProps, ...rest }) => {
  return (
    <>
      <CustomDialog fullWidth maxWidth={maxWidth} customFunction={customFunction} className={className} PaperProps={paperProps}>
        <Component {...rest} closeModal={customFunction} />
      </CustomDialog>
    </>
  )
}
RenderModalWithComponent.propTypes = {
  component: PropTypes.elementType.isRequired, // expects a React component type
  maxWidth: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.bool]),
  customFunction: PropTypes.func,
  paperProps: PropTypes.object,
  // Add any other PropTypes you need for your component's props
};